<template>
  <Dialog
    width="860px"
    :height="createRenderType == 'mobile' ? '100%' : '720px'"
    titleAlign="left"
    :title="$$t('editor.lyrics_translator')"
    v-model:visible="renderData.visible"
    @close="closeDialog"
    mobileRenderType="drawerDialog"
    :background="
      createRenderType == 'mobile' && !props.item?.song_id
        ? 'linear-gradient(180deg, rgba(165, 174, 255, 0.3) 0%, rgba(165, 174, 255, 0) 100%), black'
        : null
    "
    :customClass="`lyrics-translate-dialog ${
      createRenderType == 'mobile' ? 'lyrics-translate-dialog--mobile' : ''
    }`"
    :questionClick="renderData.editMode != 'upload' ? onQuestionClick : null"
  >
    <template v-slot:header>
      <span class="fn-inline">{{ $$t("editor.lyrics_translator") }}</span>
      <el-tooltip
        popper-class="lyrics-translate-dialog-question-popper"
        :disabled="createRenderType == 'mobile'"
        :popperOptions="{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 4],
              },
            },
          ],
        }"
      >
        <i
          class="dialog-header-question fn-inline"
          @click="
            () => {
              if (createRenderType == 'mobile') {
                onQuestionClick()
              }
            }
          "
        ></i>
        <template v-slot:content>
          <div class="lyrics-translate-dialog-question-content">
            <div class="lyrics-translate-dialog-question-content-title">
              {{ $$t("editor.notic") }}
            </div>
            <template
              v-for="(item, index) in $$t(
                'editor.translate_lyrics_notic'
              ).split('\n')"
              :key="index"
            >
              <div class="lyrics-translate-dialog-question-content-text flex">
                <i class="block"></i>
                <span class="block">
                  {{ item }}
                </span>
              </div>
            </template>
          </div>
        </template>
      </el-tooltip>
    </template>

    <div
      class="lyrics-translate-dialog-container"
      :class="{
        [`lyrics-translate-dialog-container--${createRenderType}`]: true,
      }"
    >
      <div class="lyrics-translate-dialog-edit-box">
        <div class="lyrics-translate-dialog-media-box">
          <div
            class="lyrics-translate-dialog-media-upload"
            v-if="
              renderData.editMode == 'upload' || renderData.editFilePopupVisible
            "
          >
            <AudioDragUpload
              pointTypePrefix="lyrics_translate"
              :uploadDescription="$$t('editor.cover_voice_edit_description')"
              @initEditClipFile="doInitEditClipFile"
              @syncUploadState="doSyncUploadState"
            ></AudioDragUpload>
          </div>
          <div
            class="lyrics-translate-dialog-media-processing"
            v-if="
              renderData.editMode == 'processing' &&
              !renderData.editFilePopupVisible
            "
          >
            <div class="redm-processing-loading-box">
              <div class="redm-processing-loading rotate-loading"></div>
              <div class="redm-processing-loading-ico flex-center">
                <i class="icon"> </i>
              </div>
            </div>
            <div class="lyrics-translate-dialog-media-processing-text">
              {{ $$t("editor.audio_edit_data_processing") }}
            </div>
          </div>
          <div
            class="lyrics-translate-dialog-media-processfailed"
            v-if="
              renderData.editMode == 'processfailed' &&
              !renderData.editFilePopupVisible
            "
          >
            <div class="region-processing-processfailed-ico"></div>
            <div class="lyrics-translate-dialog-media-processfailed-text">
              {{ $$t("editor.get_editing_data_failed") }}
            </div>
            <div class="lyrics-translate-dialog-media-processfailed-button">
              <Button
                @click="onRetryClick"
                :renderStyle="{
                  '--padding': '0',
                  '--width': '100%',
                  '--height': '42px',
                  '--borderRadius': '48px',
                  '--background': 'rgba(255, 255, 255, 0.2)',
                  '--fontColor': '#fff',
                  '--fontSize': '14px',
                  '--fontWeight': 'normal',
                  '--border': 'none',
                  '--backgroundHover': 'rgba(255, 255, 255, 0.3)',
                  '--fontColorHover': '#fff',
                }"
              >
                <span class="fn-inline">{{ $$t("create.retry") }}</span>
              </Button>
            </div>
          </div>

          <div
            class="lyrics-translate-dialog-media-edit"
            v-if="renderData.editMode == 'editing'"
          >
            <EditorWavePlayer
              :canSeekNotCurrent="true"
              :autoToStartIfNotCurrent="false"
              :url="renderData.audioUrl"
              :duration="renderData.audioDuration"
              :waveformData="renderData.waveformData"
              :hideRemove="renderData.hideRemove"
              @remove="doRemove"
              @syncProgress="doSyncProgress"
            ></EditorWavePlayer>
          </div>
        </div>
        <div class="lyrics-translate-dialog-lyric-box">
          <div
            class="lyrics-translate-dialog-notic"
            v-if="renderData.editMode != 'editing'"
          >
            <div class="lyrics-translate-dialog-notic-title">
              {{ $$t("editor.notic") }}
            </div>
            <template
              v-for="(item, index) in $$t(
                'editor.translate_lyrics_notic'
              ).split('\n')"
              :key="index"
            >
              <div class="lyrics-translate-dialog-notic-text">
                <i></i>

                <span>
                  {{ item }}
                </span>
              </div>
            </template>
          </div>
          <LyricsEdit
            v-if="renderData.editMode == 'editing'"
            ref="refLyricsEdit"
            :lyrics="renderData.lyrics"
            :translatedLyrics="renderData.translatedLyrics"
            :currentTime="renderData.currentTime"
            :disabled="renderData.disabledTranslated"
            @reTranslated="onReTranslated"
          ></LyricsEdit>
        </div>
      </div>
      <div class="lyrics-translate-dialog-button-box">
        <CreditsButton
          :buttonText="$$t('editor.lyrics_translate')"
          :disabled="renderData.disabledSubmit"
          :loading="renderData.loadingSubmit"
          @onClick="onSubmitClick"
        ></CreditsButton>
      </div>
    </div>
  </Dialog>
  <EditOriginalSongDialog
    ref="refEditOriginalSongDialog"
    v-model:visible="renderData.editFilePopupVisible"
    :clipSourceData="renderData.clipSourceData"
    @complete="handleEditFileCompleted"
    @cancel="handleEditFileCancel"
  ></EditOriginalSongDialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"

import { useRouter, useRoute } from "vue-router"
import globalConfig, { chinaAppName } from "@/config/config.js"

import apiEditor from "@/api/api/apiEditor.js"

import { showActionDialog } from "@/components/functionCallComponent/action/action.js"

import AudioDragUpload from "../component/audioDragUpload.vue"
import CreditsButton from "../component/creditsButton.vue"
import AddLinkDialog from "../component/addLinkDialog.vue"
import Button from "@/components/basic/button/Button.vue"
import EditorWavePlayer from "../component/editorWavePlayer.vue"
import LyricsEdit from "@/page/editor/lyricsTranslate/lyricsEdit.vue"
import EditOriginalSongDialog from "./editOriginalSongDialog.vue"

import tools from "@/utils/tools.js"
import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js"
import message from "@/components/functionCallComponent/message.jsx"
import clipUtil from "@/components/media/utils/clipUtil.js"
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js"

import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
import useUserDataStore from "@/store/userDataStore.js"
import useFeedListStore from "@/store/create/feedListDataStore.js"
import useLyricsTranslatorDataStore from "@/store/editor/lyricsTranslatorDataStore.js"

const createLayoutStore = useCreateLayoutStore()
const userDataStore = useUserDataStore()
const { createRenderType } = storeToRefs(createLayoutStore)

const feedListDataStore = useFeedListStore()
const lyricsTranslatorDataStore = useLyricsTranslatorDataStore()

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties
const Router = useRouter()
const route = useRoute()
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  pitem: {
    type: Object,
    default: null,
  },
  item: {
    type: Object,
    default: null,
  },
  visible: {
    type: Boolean,
    default: false,
  },
})

const refLyricsEdit = ref(null)
const refEditOriginalSongDialog = ref(null)
const emits = defineEmits(["update:visible"])

const stateData = {
  parseDataParams: null,
  lyricUnitTimeDataArray: [],
  disabledTranslated: false,
}

const renderData = reactive({
  visible: props.visible,
  editMode: "upload", // "upload", "processing","editing"
  addLinkDialogVisible: false,
  hideRemove: props.item?.song_id ? true : false,
  clipSourceData: null,
  title: "",
  audioUrl: "", // https://test.mureka.ai/cos-test/song/audio/20250213/music_56098979577857_PfJV1K6VMYcGNNWnzYropf_bcfiec.mp3",
  audioDuration: 0,
  waveformData: [],
  disabledSubmit: true,
  editFilePopupVisible: false,
  progress: 0,
  startTime: "00:00",
  currentTime: 0,
  lyrics: [],
  translatedLyrics: [],
  disabledTranslated: false,
  loadingSubmit: false,
})

const doDownloadFile = async (url, filename) => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open("GET", url, true)
    xhr.responseType = "blob"
    xhr.onload = function (e) {
      if (this.status === 200) {
        var blob = new Blob([this.response], {
          type: this.response?.type || "text/plain",
        })
        const resfile = new File([blob], filename, { type: blob.type })
        resolve(resfile)
      } else {
        reject(this.statusText)
      }
    }
    xhr.send()
  })
}
const closeDialog = () => {
  if (renderData.editMode === "editing") {
    showActionDialog({
      content: $$t("editor.edit_close_warning"),
      cancelLabel: $$t("editor.keep"),
      confirmLabel: $$t("create.close"),
      titleAlign: "center",
      confirm: (closeAction) => {
        closeAction()
        renderData.visible = false
      },
    })
  } else {
    renderData.visible = false
  }
}

const onQuestionClick = () => {
  showActionDialog({
    title: $$t("editor.note_on_using_lyrics_translator"),
    content: $$t("editor.translate_lyrics_notic"),
    hideCancel: true,
    confirmLabel: "ok",
    titleAlign: "left",
    confirm: (closeAction) => {
      closeAction()
    },
  })
}

const doSyncProgress = (progress, startTime, currentTime) => {
  renderData.progress = progress
  renderData.startTime = startTime
  renderData.currentTime = currentTime
}

const doRemove = async () => {
  showActionDialog({
    content: $$t("editor.edit_remove_warning"),
    cancelLabel: $$t("editor.keep"),
    confirmLabel: $$t("create.delete"),
    titleAlign: "center",
    confirm: (closeAction) => {
      closeAction()
      renderData.editMode = "upload"
      renderData.lyric = ""
      renderData.lyricSource = ""
      lyricsTranslatorDataStore.reset()
    },
  })
}

const doSyncUploadState = () => {}

const doInitEditClipBySong = async (data) => {
  if (data.duration_milliseconds > 60 * 1000) {
    const closeMsg = message.loading({
      contnet: $$t("create.downloading_wait"),
      position: "center",
    })
    doDownloadFile(getObjectStorageFullUrl(data?.mp3_url), data.title + ".mp3")
      .then((linkFile) => {
        closeMsg?.clear()
        doInitEditClipFileData({
          file: linkFile,
          title: data.title,
          duration: data.duration_milliseconds / 1000,
          isLink: false,
        })
      })
      .catch((e) => {
        closeMsg?.clear()
        reject(e)
      })
  } else {
    doInitEditData({
      title: data.title,
      resource: null,
      source_type: 0,
      cos_url: data?.mp3_url,
      duration_milliseconds: data?.duration_milliseconds,
      is_need_waves: true,
      is_need_lyrics: true,
      check_mute_duration: true,
    })
  }
}

const doInitEditData = async (data, close) => {
  renderData.editMode = "processing"
  doParseInitEditData(data, close)
}

const doInitEditClipFile = async (data) => {
  if (data.duration > 60) {
    doInitEditClipFileData(data)
  } else {
    doUploadFile(data.file, data.duration, null)
  }
}

const doInitEditClipFileData = async (data) => {
  let file = data.file
  renderData.title = data.title
  window.curSelectFile = file
  const closeMsg = message.loading({
    content: data.isLink
      ? $$t("create.parsing_link")
      : $$t("create.extract_song"),
  })
  let decodeData = null
  let blobUrl = null
  let duration = data.duration
  try {
    decodeData = await clipUtil.getDecodeDataByFile(file)
    duration = decodeData.duration
    blobUrl = (window.URL || window.webkitURL).createObjectURL(file)
  } catch (e) {
    try {
      console.log("name:", file.name, "type:", file.type, "size:", file.size)
      const outputfile = await ffmpegUtil.transFileToMp3(file)
      file = outputfile.file
      blobUrl = outputfile.blobUrl
      decodeData = await clipUtil.getDecodeDataByFile(file)
      duration = decodeData.duration
    } catch (e) {
      console.error("handleAfterReaderr", e)
      closeMsg.clear()
      message.info({
        content: $$t("create.extract_song_failed"),
      })
      return
    }
  }
  renderData.fileTemp = file
  renderData.clipSourceData = {
    duration: duration,
    isUpload: true,
    blobUrl: blobUrl,
    url: null,
    type: "audio/wav",
    decodeData,
  }
  closeMsg.clear()
  renderData.editFilePopupVisible = true
}

const handleEditFileCompleted = async (fileData, close) => {
  const { getClipedExportData, data } = fileData
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.audio_edit_data_processing"),
  })
  try {
    let clipedExportData = await getClipedExportData()
    closeMsg.clear()
    doUploadFile(clipedExportData.file, clipedExportData.duration, close)
  } catch (e) {
    closeMsg.clear()
    message.error({
      position: "top",
      content: $$t("create.save_failed"),
    })
    return
  }
}
const handleEditFileCancel = () => {
  if (props.item) {
    renderData.visible = false
  }
}

const doUploadFile = async (file, duration, close) => {
  const closeMsg = message.loading({
    position: "center",
    content: $$t("editor.audio_edit_data_processing"),
  })
  if (
    !(
      clipUtil.isMP3ByMimeType(file.type) ||
      clipUtil.isMP3ByExtension(file.name)
    )
  ) {
    try {
      const outputfile = await ffmpegUtil.transFileToMp3(file)
      file = outputfile.file
    } catch (e) {
      console.error("ffmpegUtil.transFileToMp3 error", e)
    }
  }
  const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
    file,
    (obj) => {
      renderData.uploadCallbackData = obj
    }
  )
  const saveData = {
    source_type: 2,
    title: renderData.title,
    cos_url: objectStorageRes.pathKey,
    duration_milliseconds: Math.round(duration * 1000),
  }
  closeMsg.clear()
  doInitEditData(saveData, close)
}

const onReTranslated = () => {
  renderData.disabledTranslated = true
  return new Promise((resolve, reject) => {
    apiEditor
      .parseAudioData(stateData.parseDataParams)
      .then((res) => {
        if (res.code == 200) {
          close?.()
          renderData.title = res.data.title
          renderData.lyrics = res.data.lyrics
          stateData.parseResData = res.data
          resolve()
        } else {
          if (res.code == 6346) {
            message.error({
              content: $$t("editor.check_mute_duration_warning"),
              positon: "top",
            })
            onCancelClick()
          } else if (res.code == 6316) {
            message.error({
              content: $$t("create.song_state_auditing_failed"),
              positon: "top",
            })
            onCancelClick()
          } else {
            message.error({
              content: $$t("editor.get_editing_data_failed_message"),
              positon: "top",
            })
          }
          reject("processfailed")
        }
        renderData.disabledTranslated = false
      })
      .catch((err) => {
        message.error({
          content: $$t("editor.get_editing_data_failed_message"),
          positon: "top",
        })
        reject(err)
        renderData.disabledTranslated = false
      })
  })
}

const doParseInitEditData = (data, close) => {
  renderData.editMode = "processing"
  stateData.parseDataParams = {
    resource: data.linkUrl,
    source_type: data.source_type,
    cos_url: data?.cos_url,
    duration_milliseconds: data?.duration_milliseconds,
    title: data?.title,
    is_need_waves: true,
    is_need_lyrics: true,
    check_mute_duration: true,
  }
  const closeMsg = message.loading({
    position: "center",
    content: $$t("editor.audio_edit_data_processing"),
  })
  return new Promise((resolve, reject) => {
    apiEditor
      .getTranslateAudioData(data)
      .then((res) => {
        closeMsg?.clear()
        if (res.code == 200) {
          close?.()
          renderData.waveformData = res.data.waves
          renderData.audioDuration = res.data.duration_milliseconds / 1000
          renderData.audioUrl =
            getObjectStorageFullUrl(res.data.mp3_url) + "?type=lyricsTranslator"
          renderData.title = res.data.title

          renderData.lyrics = res.data.lyrics
          renderData.translatedLyrics = res.data.translated_lyrics
          stateData.parseResData = res.data
          renderData.editMode = "editing"
          renderData.disabledSubmit = false
          resolve()
        } else {
          if (res.code == 6346) {
            message.error({
              content: $$t("editor.check_mute_duration_warning"),
              positon: "top",
            })
            renderData.editMode = "processfailed"
          } else if (res.code == 6316) {
            message.error({
              content: $$t("create.song_state_auditing_failed"),
              positon: "top",
            })
            renderData.editMode = "processfailed"
          } else {
            message.error({
              content: $$t("editor.get_editing_data_failed_message"),
              positon: "top",
            })
            renderData.editMode = "processfailed"
          }
          reject("processfailed")
        }
      })
      .catch((err) => {
        closeMsg?.clear()
        message.error({
          content: $$t("editor.get_editing_data_failed_message"),
          positon: "top",
        })
        renderData.editMode = "processfailed"
        reject(err)
      })
  })
}

const onSubmitClick = () => {
  renderData.loadingSubmit = true
  feedListDataStore
    .doLyricTranslatorSongDoneReGenerate({
      outer_song: {
        id: stateData.parseResData.id,
      },
      translated_lyrics: refLyricsEdit.value?.getTranslatedLyrics(),
    })
    .then(() => {
      renderData.visible = false
      emits("regenerate", props.pitem, props.item)
      renderData.loadingSubmit = false
    })
    .catch((err) => {
      renderData.loadingSubmit = false
      callback(err)
    })
  globalProperties.logCustomEvent("lyrics_translate_button_click", {
    tab_stare: "lyrics_translate",
    content_id: props.item?.song_id,
    source: props.item?.song_id
      ? "mysong"
      : stateData.parseDataParams?.source_type == 1
      ? "youtube_link_upload"
      : "file_upload",
  })
}

const onRetryClick = (type) => {
  doParseInitEditData(stateData.parseDataParams)
}

const onCancelClick = () => {
  renderData.editMode = "upload"
  renderData.lyric = ""
  renderData.lyricSource = ""
  lyricsTranslatorDataStore.reset()
  stateData.lyricUnitTimeDataArray = []
}

const initTestData = () => {
  const res = {
    code: 0,
    msg: "OK",
    data: {
      id: 60295200374785,
      title: "7ffe891a700a4d1bb02b359bcb3b4289",
      user_id: 16201201745921,
      duration_milliseconds: 245110,
      mp3_url:
        "cos-test/files/16201201745921/20250308/b136e3c9-3160-456b-8199-27f64a00c7d4.mp3",
      waves: [
        0.061, 0.48, 0.29, 0.172, 0.118, 0.067, 0.054, 0.044, 0.142, 0.086,
        0.055, 0.043, 0.035, 0.034, 0.03, 0.374, 0.281, 0.172, 0.118, 0.059,
        0.035, 0.025, 0.076, 0.066, 0.033, 0.02, 0.019, 0.013, 0.012, 0.183,
        0.389, 0.196, 0.143, 0.091, 0.064, 0.053, 0.056, 0.127, 0.074, 0.063,
        0.045, 0.038, 0.036, 0.032, 0.378, 0.248, 0.116, 0.094, 0.044, 0.035,
        0.023, 0.103, 0.061, 0.035, 0.023, 0.016, 0.011, 0.009, 0.293, 0.328,
        0.193, 0.141, 0.096, 0.069, 0.054, 0.079, 0.103, 0.064, 0.038, 0.025,
        0.02, 0.017, 0.065, 0.441, 0.225, 0.148, 0.1, 0.056, 0.05, 0.037, 0.136,
        0.064, 0.038, 0.025, 0.024, 0.025, 0.026, 0.346, 0.275, 0.16, 0.125,
        0.056, 0.036, 0.03, 0.083, 0.094, 0.063, 0.055, 0.039, 0.037, 0.034,
        0.217, 0.369, 0.161, 0.112, 0.056, 0.026, 0.017, 0.024, 0.1, 0.032,
        0.019, 0.132, 0.225, 0.29, 0.31, 0.665, 0.502, 0.349, 0.312, 0.246,
        0.264, 0.264, 0.368, 0.444, 0.451, 0.427, 0.324, 0.218, 0.16, 0.451,
        0.652, 0.509, 0.423, 0.319, 0.232, 0.198, 0.255, 0.377, 0.384, 0.318,
        0.163, 0.067, 0.061, 0.094, 0.585, 0.341, 0.237, 0.137, 0.061, 0.045,
        0.037, 0.125, 0.084, 0.071, 0.051, 0.032, 0.035, 0.042, 0.376, 0.266,
        0.142, 0.099, 0.042, 0.029, 0.023, 0.077, 0.055, 0.027, 0.033, 0.145,
        0.211, 0.244, 0.559, 0.719, 0.493, 0.458, 0.339, 0.308, 0.293, 0.095,
        0.411, 0.482, 0.451, 0.412, 0.354, 0.232, 0.191, 0.82, 0.678, 0.521,
        0.493, 0.375, 0.147, 0.213, 0.303, 0.205, 0.112, 0.099, 0.069, 0.058,
        0.012, 0.407, 0.495, 0.332, 0.242, 0.145, 0.091, 0.06, 0.079, 0.185,
        0.175, 0.124, 0.074, 0.059, 0.048, 0.166, 0.319, 0.151, 0.097, 0.062,
        0.04, 0.022, 0.028, 0.11, 0.051, 0.126, 0.184, 0.264, 0.109, 0.129,
        0.545, 0.493, 0.393, 0.25, 0.126, 0.08, 0.048, 0.08, 0.063, 0.038,
        0.073, 0.226, 0.178, 0.165, 0.386, 0.577, 0.494, 0.326, 0.203, 0.117,
        0.118, 0.119, 0.203, 0.192, 0.152, 0.116, 0.057, 0.019, 0.034, 0.444,
        0.283, 0.161, 0.094, 0.072, 0.043, 0.041, 0.113, 0.078, 0.065, 0.055,
        0.045, 0.036, 0.029, 0.291, 0.206, 0.109, 0.086, 0.032, 0.026, 0.017,
        0.073, 0.103, 0.075, 0.112, 0.096, 0.112, 0.119, 0.222, 0.394, 0.258,
        0.186, 0.139, 0.109, 0.071, 0.079, 0.127, 0.072, 0.05, 0.042, 0.073,
        0.066, 0.036, 0.371, 0.199, 0.118, 0.074, 0.046, 0.036, 0.026, 0.072,
        0.048, 0.025, 0.022, 0.019, 0.017, 0.014, 0.243, 0.259, 0.123, 0.103,
        0.055, 0.038, 0.026, 0.02, 0.021, 0.02, 0.015, 0.13, 0.196, 0.044,
        0.025, 0.249, 0.264, 0.335, 0.314, 0.205, 0.032, 0.031, 0.257, 0.293,
        0.177, 0.056, 0.048, 0.147, 0.259, 0.445, 0.388, 0.291, 0.273, 0.364,
        0.304, 0.284, 0.302, 0.268, 0.33, 0.388, 0.35, 0.331, 0.26, 0.373,
        0.544, 0.344, 0.222, 0.211, 0.268, 0.242, 0.238, 0.262, 0.284, 0.398,
        0.344, 0.252, 0.33, 0.443, 0.603, 0.535, 0.444, 0.379, 0.373, 0.302,
        0.296, 0.363, 0.376, 0.252, 0.233, 0.25, 0.281, 0.288, 0.5, 0.548,
        0.392, 0.298, 0.348, 0.336, 0.245, 0.314, 0.5, 0.452, 0.38, 0.383,
        0.295, 0.364, 0.399, 0.564, 0.377, 0.322, 0.258, 0.269, 0.232, 0.241,
        0.306, 0.271, 0.285, 0.292, 0.295, 0.222, 0.273, 0.569, 0.455, 0.389,
        0.298, 0.262, 0.273, 0.264, 0.309, 0.275, 0.249, 0.261, 0.249, 0.228,
        0.24, 0.382, 0.466, 0.353, 0.32, 0.277, 0.241, 0.236, 0.266, 0.288,
        0.254, 0.245, 0.366, 0.34, 0.264, 0.344, 0.631, 0.562, 0.587, 0.543,
        0.399, 0.247, 0.213, 0.486, 0.48, 0.364, 0.284, 0.276, 0.32, 0.435,
        0.49, 0.444, 0.364, 0.29, 0.34, 0.326, 0.254, 0.323, 0.297, 0.31, 0.399,
        0.348, 0.232, 0.27, 0.356, 0.754, 0.49, 0.339, 0.333, 0.374, 0.31,
        0.274, 0.326, 0.288, 0.364, 0.265, 0.253, 0.229, 0.334, 0.558, 0.607,
        0.54, 0.565, 0.531, 0.477, 0.435, 0.4, 0.368, 0.258, 0.218, 0.237,
        0.241, 0.337, 0.42, 0.494, 0.406, 0.325, 0.339, 0.383, 0.362, 0.325,
        0.439, 0.337, 0.284, 0.291, 0.386, 0.367, 0.337, 0.576, 0.395, 0.299,
        0.255, 0.24, 0.225, 0.216, 0.298, 0.242, 0.234, 0.217, 0.211, 0.191,
        0.182, 0.455, 0.348, 0.317, 0.338, 0.31, 0.284, 0.261, 0.307, 0.274,
        0.239, 0.231, 0.232, 0.261, 0.256, 0.312, 0.512, 0.349, 0.347, 0.223,
        0.206, 0.186, 0.196, 0.261, 0.196, 0.203, 0.214, 0.211, 0.216, 0.226,
        0.462, 0.333, 0.242, 0.242, 0.188, 0.192, 0.204, 0.265, 0.225, 0.229,
        0.268, 0.312, 0.289, 0.314, 0.476, 0.45, 0.343, 0.263, 0.148, 0.092,
        0.068, 0.149, 0.347, 0.388, 0.351, 0.321, 0.348, 0.283, 0.364, 0.682,
        0.555, 0.42, 0.301, 0.255, 0.255, 0.256, 0.309, 0.27, 0.321, 0.273,
        0.066, 0.081, 0.029, 0.53, 0.441, 0.405, 0.328, 0.273, 0.189, 0.074,
        0.201, 0.25, 0.243, 0.217, 0.153, 0.074, 0.068, 0.287, 0.375, 0.24,
        0.122, 0.092, 0.049, 0.03, 0.083, 0.108, 0.1, 0.053, 0.103, 0.179, 0.12,
        0.087, 0.447, 0.334, 0.294, 0.167, 0.091, 0.063, 0.05, 0.133, 0.082,
        0.036, 0.099, 0.417, 0.352, 0.289, 0.511, 0.502, 0.37, 0.269, 0.165,
        0.114, 0.118, 0.19, 0.258, 0.208, 0.204, 0.294, 0.357, 0.295, 0.393,
        0.682, 0.544, 0.278, 0.18, 0.125, 0.229, 0.216, 0.27, 0.262, 0.204,
        0.188, 0.159, 0.066, 0.051, 0.437, 0.327, 0.23, 0.123, 0.071, 0.035,
        0.025, 0.123, 0.072, 0.037, 0.115, 0.266, 0.304, 0.219, 0.311, 0.567,
        0.503, 0.296, 0.343, 0.348, 0.212, 0.155, 0.256, 0.218, 0.161, 0.225,
        0.302, 0.257, 0.288, 0.525, 0.385, 0.318, 0.29, 0.207, 0.323, 0.245,
        0.239, 0.125, 0.129, 0.153, 0.174, 0.147, 0.091, 0.317, 0.293, 0.196,
        0.114, 0.097, 0.06, 0.046, 0.109, 0.092, 0.055, 0.051, 0.054, 0.05,
        0.041, 0.211, 0.544, 0.435, 0.346, 0.294, 0.275, 0.303, 0.276, 0.214,
        0.147, 0.286, 0.252, 0.167, 0.139, 0.076, 0.428, 0.285, 0.206, 0.138,
        0.074, 0.039, 0.024, 0.103, 0.063, 0.03, 0.021, 0.019, 0.018, 0.015,
        0.21, 0.318, 0.199, 0.134, 0.098, 0.051, 0.039, 0.078, 0.102, 0.046,
        0.027, 0.075, 0.153, 0.136, 0.18, 0.358, 0.214, 0.122, 0.09, 0.067,
        0.05, 0.042, 0.042, 0.039, 0.034, 0.154, 0.28, 0.084, 0.067, 0.383,
        0.342, 0.357, 0.373, 0.301, 0.086, 0.046, 0.288, 0.326, 0.213, 0.12,
        0.094, 0.134, 0.275, 0.504, 0.526, 0.428, 0.293, 0.5, 0.481, 0.275,
        0.26, 0.29, 0.259, 0.457, 0.426, 0.358, 0.245, 0.364, 0.747, 0.49,
        0.339, 0.295, 0.428, 0.328, 0.254, 0.33, 0.323, 0.431, 0.417, 0.342,
        0.351, 0.517, 0.683, 0.634, 0.545, 0.486, 0.385, 0.333, 0.315, 0.38,
        0.439, 0.356, 0.199, 0.239, 0.271, 0.257, 0.369, 0.645, 0.532, 0.345,
        0.365, 0.429, 0.283, 0.269, 0.503, 0.448, 0.401, 0.374, 0.31, 0.321,
        0.348, 0.617, 0.537, 0.477, 0.301, 0.303, 0.248, 0.218, 0.314, 0.235,
        0.247, 0.294, 0.325, 0.311, 0.26, 0.484, 0.637, 0.469, 0.356, 0.29,
        0.265, 0.264, 0.303, 0.295, 0.258, 0.241, 0.231, 0.218, 0.232, 0.261,
        0.602, 0.513, 0.348, 0.275, 0.246, 0.237, 0.218, 0.304, 0.268, 0.256,
        0.359, 0.447, 0.266, 0.257, 0.725, 0.658, 0.59, 0.456, 0.456, 0.296,
        0.194, 0.344, 0.493, 0.355, 0.274, 0.227, 0.245, 0.407, 0.528, 0.607,
        0.504, 0.328, 0.443, 0.453, 0.313, 0.249, 0.346, 0.266, 0.407, 0.441,
        0.423, 0.252, 0.251, 0.715, 0.608, 0.389, 0.32, 0.429, 0.361, 0.3,
        0.364, 0.259, 0.424, 0.303, 0.371, 0.334, 0.461, 0.612, 0.586, 0.397,
        0.409, 0.36, 0.363, 0.427, 0.386, 0.399, 0.298, 0.233, 0.244, 0.232,
        0.359, 0.45, 0.757, 0.469, 0.224, 0.262, 0.307, 0.33, 0.332, 0.543,
        0.386, 0.299, 0.285, 0.469, 0.36, 0.265, 0.585, 0.463, 0.371, 0.278,
        0.296, 0.271, 0.251, 0.326, 0.284, 0.246, 0.246, 0.238, 0.245, 0.226,
        0.416, 0.577, 0.385, 0.387, 0.364, 0.356, 0.329, 0.333, 0.37, 0.286,
        0.259, 0.257, 0.267, 0.289, 0.312, 0.603, 0.444, 0.404, 0.356, 0.356,
        0.319, 0.317, 0.404, 0.325, 0.286, 0.298, 0.295, 0.293, 0.302, 0.526,
        0.413, 0.252, 0.241, 0.188, 0.21, 0.222, 0.273, 0.254, 0.231, 0.236,
        0.246, 0.263, 0.272, 0.43, 0.82, 0.668, 0.514, 0.524, 0.498, 0.452,
        0.51, 0.685, 0.671, 0.516, 0.626, 0.495, 0.533, 0.447, 0.816, 0.673,
        0.702, 0.675, 0.691, 0.62, 0.502, 0.557, 0.61, 0.689, 0.595, 0.495,
        0.49, 0.453, 0.608, 0.717, 0.62, 0.509, 0.62, 0.543, 0.518, 0.491,
        0.589, 0.529, 0.527, 0.486, 0.499, 0.504, 0.575, 0.775, 0.626, 0.547,
        0.72, 0.575, 0.474, 0.443, 0.489, 0.607, 0.457, 0.402, 0.421, 0.46,
        0.44, 0.748, 0.688, 0.676, 0.575, 0.643, 0.533, 0.452, 0.452, 0.472,
        0.406, 0.397, 0.413, 0.441, 0.489, 0.547, 0.643, 0.492, 0.476, 0.47,
        0.446, 0.427, 0.429, 0.444, 0.36, 0.346, 0.377, 0.404, 0.407, 0.421,
        0.672, 0.484, 0.47, 0.418, 0.404, 0.434, 0.422, 0.443, 0.389, 0.366,
        0.378, 0.358, 0.351, 0.348, 0.516, 0.469, 0.276, 0.302, 0.298, 0.271,
        0.263, 0.305, 0.334, 0.277, 0.305, 0.269, 0.268, 0.278, 0.31, 0.719,
        0.493, 0.44, 0.431, 0.435, 0.428, 0.394, 0.568, 0.53, 0.558, 0.635,
        0.546, 0.553, 0.549, 0.833, 0.583, 0.528, 0.512, 0.516, 0.486, 0.503,
        0.628, 0.684, 0.659, 0.632, 0.587, 0.631, 0.744, 0.793, 0.754, 0.677,
        0.712, 0.675, 0.576, 0.549, 0.647, 0.708, 0.717, 0.704, 0.684, 0.694,
        0.614, 0.615, 0.973, 0.833, 0.667, 0.517, 0.553, 0.507, 0.56, 0.642,
        0.659, 0.585, 0.685, 0.643, 0.495, 0.416, 0.82, 0.818, 0.78, 0.733,
        0.744, 0.716, 0.695, 0.753, 0.666, 0.727, 0.614, 0.798, 0.694, 0.674,
        0.73, 0.952, 0.748, 0.734, 0.569, 0.527, 0.537, 0.488, 0.575, 0.607,
        0.591, 0.625, 0.596, 0.662, 0.622, 0.849, 0.739, 0.643, 0.642, 0.5,
        0.516, 0.471, 0.491, 0.446, 0.405, 0.424, 0.382, 0.367, 0.393, 0.544,
        0.518, 0.337, 0.319, 0.26, 0.266, 0.271, 0.285, 0.309, 0.258, 0.241,
        0.239, 0.215, 0.223, 0.254, 0.774, 0.649, 0.602, 0.569, 0.503, 0.41,
        0.379, 0.405, 0.348, 0.324, 0.334, 0.315, 0.306, 0.334, 0.696, 0.646,
        0.51, 0.513, 0.538, 0.465, 0.471, 0.439, 0.406, 0.394, 0.402, 0.395,
        0.365, 0.355, 0.392, 0.676, 0.488, 0.407, 0.356, 0.336, 0.32, 0.321,
        0.393, 0.316, 0.303, 0.279, 0.263, 0.239, 0.246, 0.491, 0.327, 0.207,
        0.175, 0.137, 0.167, 0.171, 0.251, 0.218, 0.202, 0.199, 0.204, 0.201,
        0.205, 0.542, 0.627, 0.583, 0.52, 0.478, 0.472, 0.481, 0.48, 0.458,
        0.473, 0.497, 0.463, 0.453, 0.415, 0.435, 0.656, 0.482, 0.431, 0.409,
        0.391, 0.356, 0.373, 0.443, 0.422, 0.439, 0.429, 0.427, 0.385, 0.382,
        0.563, 0.541, 0.382, 0.345, 0.36, 0.326, 0.278, 0.344, 0.315, 0.29,
        0.295, 0.281, 0.255, 0.249, 0.409, 0.51, 0.44, 0.398, 0.272, 0.198,
        0.186, 0.195, 0.25, 0.198, 0.186, 0.182, 0.193, 0.208, 0.197, 0.404,
        0.294, 0.179, 0.177, 0.102, 0.08, 0.09, 0.163, 0.245, 0.23, 0.198,
        0.197, 0.15, 0.033, 0.362, 0.42, 0.296, 0.233, 0.162, 0.108, 0.1, 0.13,
        0.318, 0.172, 0.112, 0.035, 0.044, 0.164, 0.209, 0.354, 0.132, 0.111,
        0.069, 0.043, 0.044, 0.037, 0.044, 0.035, 0.025, 0.025, 0.022, 0.02,
        0.021, 0.297, 0.15, 0.065, 0.052, 0.027, 0.013, 0.005, 0.02, 0.017,
        0.007, 0.005, 0.004, 0.004, 0.005, 0.198, 0.312, 0.214, 0.142, 0.076,
        0.051, 0.039, 0.049, 0.283, 0.238, 0.213, 0.204, 0.159, 0.165, 0.219,
        0.581, 0.419, 0.184, 0.122, 0.055, 0.033, 0.046, 0.141, 0.216, 0.181,
        0.093, 0.045, 0.02, 0.014, 0.36, 0.281, 0.136, 0.102, 0.057, 0.037,
        0.029, 0.032, 0.032, 0.026, 0.018, 0.011, 0.01, 0.009, 0.085, 0.252,
        0.076, 0.051, 0.028, 0.013, 0.007, 0.007, 0.019, 0.009, 0.005, 0.042,
        0.105, 0.14, 0.121, 0.419, 0.288, 0.15, 0.113, 0.067, 0.056, 0.042,
        0.043, 0.039, 0.028, 0.017, 0.014, 0.013, 0.013, 0.241, 0.372, 0.258,
        0.183, 0.118, 0.102, 0.105, 0.061, 0.037, 0.026, 0.022, 0.02, 0.02,
        0.047, 0.102, 0.366, 0.164, 0.084, 0.063, 0.039, 0.027, 0.018, 0.033,
        0.021, 0.013, 0.008, 0.005, 0.004, 0.003, 0.246, 0.145, 0.043, 0.041,
        0.019, 0.009, 0.005, 0.012, 0.014, 0.005, 0.002, 0.002, 0.003, 0.002,
        0.186, 0.364, 0.175, 0.101, 0.043, 0.019, 0.008, 0.011, 0.013, 0.005,
        0.002, 0.001, 0.001, 0.001, 0.014, 0.324, 0.244, 0.146, 0.11, 0.079,
        0.049, 0.027, 0.018, 0.007, 0.003, 0.001, 0.001, 0.016, 0.022, 0.167,
        0.189, 0.072, 0.052, 0.021, 0.01, 0.003, 0.001, 0.001, 0.001, 0.001,
        0.001, 0.001, 0.001, 0.001, 0.001, 0.001, 0.001, 0.001, 0.007, 0.241,
        0.344, 0.401, 0.333, 0.201, 0.278, 0.291, 0.211, 0.123, 0.29, 0.282,
        0.157, 0.063, 0.406, 0.315, 0.295, 0.245, 0.179, 0.319, 0.425, 0.36,
        0.271, 0.211, 0.74, 1, 0.793, 0.588, 0.657, 0.817, 0.712, 0.545, 0.626,
        0.635, 0.74, 0.706, 0.754, 0.789, 0.876, 1, 0.986, 0.879, 0.778, 0.725,
        0.679, 0.783, 0.794, 0.82, 0.662, 0.462, 0.491, 0.492, 0.406, 0.866,
        0.979, 0.806, 0.517, 0.582, 0.621, 0.545, 0.684, 0.814, 0.687, 0.558,
        0.519, 0.449, 0.672, 0.76, 1, 0.827, 0.785, 0.629, 0.695, 0.639, 0.56,
        0.691, 0.64, 0.73, 0.754, 0.914, 0.702, 0.624, 0.983, 0.989, 0.889,
        0.967, 0.954, 0.854, 0.874, 0.898, 0.947, 0.923, 0.928, 0.911, 0.905,
        0.857, 0.945, 0.999, 0.812, 0.713, 0.577, 0.58, 0.634, 0.647, 0.594,
        0.484, 0.467, 0.441, 0.441, 0.426, 0.435, 1, 0.725, 0.633, 0.548, 0.534,
        0.585, 0.562, 0.58, 0.56, 0.519, 0.492, 0.482, 0.471, 0.479, 0.92,
        0.895, 0.845, 0.778, 0.769, 0.757, 0.717, 0.843, 0.864, 0.906, 0.972,
        0.849, 0.823, 0.816, 0.723, 1, 0.909, 0.743, 0.797, 0.952, 0.967, 0.964,
        1, 1, 1, 1, 1, 1, 1, 1, 1, 0.856, 0.911, 0.892, 0.851, 0.987, 1, 1, 1,
        1, 1, 1, 1, 1, 1, 1, 1, 1, 0.975, 0.984, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
        1, 1, 1, 1, 1, 1, 0.946, 0.995, 1, 1, 1, 1, 1, 0.967, 0.757, 0.753,
        0.818, 0.823, 0.756, 0.77, 0.635, 0.629, 0.651, 0.632, 0.688, 0.68,
        0.937, 1, 0.887, 0.802, 0.685, 0.723, 0.69, 0.767, 0.72, 0.724, 0.693,
        0.659, 0.722, 0.742, 0.711, 1, 0.706, 0.696, 0.668, 0.678, 0.63, 0.608,
        0.721, 0.649, 0.547, 0.533, 0.54, 0.546, 0.571, 1, 0.995, 0.871, 0.897,
        0.762, 0.796, 0.744, 0.896, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.987, 1, 1, 1, 1, 0.981, 1, 1, 1,
        1, 1, 1, 0.979, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.963, 1, 0.928, 1, 1, 1, 0.88, 0.945,
        1, 1, 1, 1, 0.892, 0.837, 0.845, 0.868, 0.814, 0.692, 0.68, 0.694,
        0.628, 0.688, 0.684, 0.988, 0.77, 0.65, 0.558, 0.621, 0.551, 0.611,
        0.666, 0.544, 0.495, 0.439, 0.439, 0.413, 0.392, 0.364, 0.352, 0.293,
        0.262, 0.227, 0.207, 0.192, 0.181, 0.169, 0.161, 0.152, 0.13, 0.114,
        0.103, 0.092, 0.074, 0.071, 0.063, 0.059, 0.058, 0.044, 0.038, 0.031,
        0.022, 0.018, 0.013, 0.011, 0.008, 0.007, 0.005, 0.003, 0.002, 0.002,
        0.001, 0.001, 0.001, 0.001, 0.001, 0.001, 0.001, 0.001, 0.001, 0.001,
      ],
      lyrics: [
        {
          end: 237674,
          rows: [
            {},
            {
              start: 13777,
              end: 18457,
              text: "When I was down and out;",
              words: [
                {
                  start: 13777,
                  end: 14057,
                  text: "When ",
                },
                {
                  start: 14657,
                  end: 14657,
                  text: "I ",
                },
                {
                  start: 15056,
                  end: 15837,
                  text: "was ",
                },
                {
                  start: 15956,
                  end: 16817,
                  text: "down ",
                },
                {
                  start: 17017,
                  end: 17717,
                  text: "and ",
                },
                {
                  start: 17837,
                  end: 18457,
                  text: "out;",
                },
              ],
            },
            {},
            {
              start: 20756,
              end: 27616,
              text: "My mother took me by the hand;",
              words: [
                {
                  start: 20756,
                  end: 21017,
                  text: "My ",
                },
                {
                  start: 21217,
                  end: 22756,
                  text: "mother ",
                },
                {
                  start: 22997,
                  end: 23697,
                  text: "took ",
                },
                {
                  start: 23877,
                  end: 24037,
                  text: "me ",
                },
                {
                  start: 24777,
                  end: 25317,
                  text: "by ",
                },
                {
                  start: 25657,
                  end: 25817,
                  text: "the ",
                },
                {
                  start: 26537,
                  end: 27616,
                  text: "hand;",
                },
              ],
            },
            {
              start: 27817,
              end: 31916,
              text: "She said, son, it's time to go;",
              words: [
                {
                  start: 27817,
                  end: 27917,
                  text: "She ",
                },
                {
                  start: 28256,
                  end: 28877,
                  text: "said, ",
                },
                {
                  start: 28977,
                  end: 29077,
                  text: "son, ",
                },
                {
                  start: 29677,
                  end: 29916,
                  text: "it's ",
                },
                {
                  start: 30037,
                  end: 30797,
                  text: "time ",
                },
                {
                  start: 30897,
                  end: 31037,
                  text: "to ",
                },
                {
                  start: 31797,
                  end: 31916,
                  text: "go;",
                },
              ],
            },
            {},
            {
              start: 34577,
              end: 36957,
              text: "Out of my misery;",
              words: [
                {
                  start: 34577,
                  end: 34697,
                  text: "Out ",
                },
                {
                  start: 34757,
                  end: 34876,
                  text: "of ",
                },
                {
                  start: 35317,
                  end: 35457,
                  text: "my ",
                },
                {
                  start: 36297,
                  end: 36957,
                  text: "misery;",
                },
              ],
            },
            {},
            {
              start: 40197,
              end: 43157,
              text: "You know I'm gonna make it;",
              words: [
                {
                  start: 40197,
                  end: 40397,
                  text: "You ",
                },
                {
                  start: 40516,
                  end: 41037,
                  text: "know ",
                },
                {
                  start: 41177,
                  end: 41317,
                  text: "I'm ",
                },
                {
                  start: 41516,
                  end: 42037,
                  text: "gonna ",
                },
                {
                  start: 42157,
                  end: 42857,
                  text: "make ",
                },
                {
                  start: 42957,
                  end: 43157,
                  text: "it;",
                },
              ],
            },
            {
              start: 43553,
              end: 46993,
              text: "I'll make it somehow, yeah;",
              words: [
                {
                  start: 43553,
                  end: 44013,
                  text: "I'll ",
                },
                {
                  start: 44153,
                  end: 44653,
                  text: "make ",
                },
                {
                  start: 44753,
                  end: 45053,
                  text: "it ",
                },
                {
                  start: 45293,
                  end: 46673,
                  text: "somehow, ",
                },
                {
                  start: 46772,
                  end: 46993,
                  text: "yeah;",
                },
              ],
            },
            {
              start: 47853,
              end: 52053,
              text: "I'll get by with a little help from my friends;",
              words: [
                {
                  start: 47853,
                  end: 48013,
                  text: "I'll ",
                },
                {
                  start: 48132,
                  end: 48373,
                  text: "get ",
                },
                {
                  start: 48553,
                  end: 48873,
                  text: "by ",
                },
                {
                  start: 48992,
                  end: 49173,
                  text: "with ",
                },
                {
                  start: 49293,
                  end: 49293,
                  text: "a ",
                },
                {
                  start: 49413,
                  end: 49793,
                  text: "little ",
                },
                {
                  start: 49893,
                  end: 50173,
                  text: "help ",
                },
                {
                  start: 50553,
                  end: 50693,
                  text: "from ",
                },
                {
                  start: 50772,
                  end: 50973,
                  text: "my ",
                },
                {
                  start: 51153,
                  end: 52053,
                  text: "friends;",
                },
              ],
            },
            {},
            {
              start: 54293,
              end: 57213,
              text: "You know I'm gonna make it;",
              words: [
                {
                  start: 54293,
                  end: 54433,
                  text: "You ",
                },
                {
                  start: 54653,
                  end: 55093,
                  text: "know ",
                },
                {
                  start: 55253,
                  end: 55393,
                  text: "I'm ",
                },
                {
                  start: 55593,
                  end: 56132,
                  text: "gonna ",
                },
                {
                  start: 56272,
                  end: 56693,
                  text: "make ",
                },
                {
                  start: 57053,
                  end: 57213,
                  text: "it;",
                },
              ],
            },
            {
              start: 57632,
              end: 61033,
              text: "Yeah, if I can make it here;",
              words: [
                {
                  start: 57632,
                  end: 57853,
                  text: "Yeah, ",
                },
                {
                  start: 57913,
                  end: 58193,
                  text: "if ",
                },
                {
                  start: 58593,
                  end: 58593,
                  text: "I ",
                },
                {
                  start: 58713,
                  end: 59013,
                  text: "can ",
                },
                {
                  start: 59393,
                  end: 59613,
                  text: "make ",
                },
                {
                  start: 59673,
                  end: 59733,
                  text: "it ",
                },
                {
                  start: 59833,
                  end: 61033,
                  text: "here;",
                },
              ],
            },
            {
              start: 61173,
              end: 71253,
              text: "I can make it anywhere;",
              words: [
                {
                  start: 61173,
                  end: 61173,
                  text: "I ",
                },
                {
                  start: 61573,
                  end: 61693,
                  text: "can ",
                },
                {
                  start: 61813,
                  end: 62132,
                  text: "make ",
                },
                {
                  start: 62373,
                  end: 62712,
                  text: "it ",
                },
                {
                  start: 62813,
                  end: 71253,
                  text: "anywhere;",
                },
              ],
            },
            {
              start: 71601,
              end: 76782,
              text: "Around with a broken nose;",
              words: [
                {
                  start: 71601,
                  end: 73101,
                  text: "Around ",
                },
                {
                  start: 73282,
                  end: 73862,
                  text: "with ",
                },
                {
                  start: 73942,
                  end: 73942,
                  text: "a ",
                },
                {
                  start: 74062,
                  end: 75601,
                  text: "broken ",
                },
                {
                  start: 75862,
                  end: 76782,
                  text: "nose;",
                },
              ],
            },
            {
              start: 77321,
              end: 79541,
              text: "A girl called me;",
              words: [
                {
                  start: 77321,
                  end: 77321,
                  text: "A ",
                },
                {
                  start: 77642,
                  end: 78041,
                  text: "girl ",
                },
                {
                  start: 78082,
                  end: 78961,
                  text: "called ",
                },
                {
                  start: 79401,
                  end: 79541,
                  text: "me;",
                },
              ],
            },
            {
              start: 80262,
              end: 82982,
              text: "She said why don′t we go;",
              words: [
                {
                  start: 80262,
                  end: 80362,
                  text: "She ",
                },
                {
                  start: 80702,
                  end: 81082,
                  text: "said ",
                },
                {
                  start: 81142,
                  end: 81601,
                  text: "why ",
                },
                {
                  start: 81801,
                  end: 82161,
                  text: "don′t ",
                },
                {
                  start: 82241,
                  end: 82401,
                  text: "we ",
                },
                {
                  start: 82901,
                  end: 82982,
                  text: "go;",
                },
              ],
            },
            {
              start: 84262,
              end: 88362,
              text: "Together through the wind and rain;",
              words: [
                {
                  start: 84262,
                  end: 85381,
                  text: "Together ",
                },
                {
                  start: 85541,
                  end: 85961,
                  text: "through ",
                },
                {
                  start: 86021,
                  end: 86121,
                  text: "the ",
                },
                {
                  start: 86461,
                  end: 87101,
                  text: "wind ",
                },
                {
                  start: 87502,
                  end: 87722,
                  text: "and ",
                },
                {
                  start: 87821,
                  end: 88362,
                  text: "rain;",
                },
              ],
            },
            {
              start: 89502,
              end: 91722,
              text: "Oh yes we did;",
              words: [
                {
                  start: 89502,
                  end: 89961,
                  text: "Oh ",
                },
                {
                  start: 90601,
                  end: 91021,
                  text: "yes ",
                },
                {
                  start: 91142,
                  end: 91262,
                  text: "we ",
                },
                {
                  start: 91461,
                  end: 91722,
                  text: "did;",
                },
              ],
            },
            {},
            {
              start: 96642,
              end: 99062,
              text: "You know I'm gonna make;",
              words: [
                {
                  start: 96642,
                  end: 96741,
                  text: "You ",
                },
                {
                  start: 96961,
                  end: 97422,
                  text: "know ",
                },
                {
                  start: 97582,
                  end: 97722,
                  text: "I'm ",
                },
                {
                  start: 97901,
                  end: 98442,
                  text: "gonna ",
                },
                {
                  start: 98562,
                  end: 99062,
                  text: "make;",
                },
              ],
            },
            {
              start: 99952,
              end: 104312,
              text: "Yeah, I'll make it somehow, yeah;",
              words: [
                {
                  start: 99952,
                  end: 100172,
                  text: "Yeah, ",
                },
                {
                  start: 100232,
                  end: 100392,
                  text: "I'll ",
                },
                {
                  start: 100532,
                  end: 101131,
                  text: "make ",
                },
                {
                  start: 101292,
                  end: 101312,
                  text: "it ",
                },
                {
                  start: 101692,
                  end: 102672,
                  text: "somehow, ",
                },
                {
                  start: 103232,
                  end: 104312,
                  text: "yeah;",
                },
              ],
            },
            {
              start: 104352,
              end: 108491,
              text: "I'll get by with a little help from my friends;",
              words: [
                {
                  start: 104352,
                  end: 104452,
                  text: "I'll ",
                },
                {
                  start: 104551,
                  end: 104832,
                  text: "get ",
                },
                {
                  start: 104991,
                  end: 105312,
                  text: "by ",
                },
                {
                  start: 105411,
                  end: 105652,
                  text: "with ",
                },
                {
                  start: 105712,
                  end: 105712,
                  text: "a ",
                },
                {
                  start: 105792,
                  end: 106271,
                  text: "little ",
                },
                {
                  start: 106312,
                  end: 106551,
                  text: "help ",
                },
                {
                  start: 106972,
                  end: 107112,
                  text: "from ",
                },
                {
                  start: 107192,
                  end: 107392,
                  text: "my ",
                },
                {
                  start: 107572,
                  end: 108491,
                  text: "friends;",
                },
              ],
            },
            {},
            {
              start: 110711,
              end: 113652,
              text: "You know I'm gonna make it;",
              words: [
                {
                  start: 110711,
                  end: 110911,
                  text: "You ",
                },
                {
                  start: 111072,
                  end: 111551,
                  text: "know ",
                },
                {
                  start: 111692,
                  end: 111852,
                  text: "I'm ",
                },
                {
                  start: 112032,
                  end: 112572,
                  text: "gonna ",
                },
                {
                  start: 112692,
                  end: 113472,
                  text: "make ",
                },
                {
                  start: 113612,
                  end: 113652,
                  text: "it;",
                },
              ],
            },
            {
              start: 114072,
              end: 116592,
              text: "Yeah, if I can make it here,",
              words: [
                {
                  start: 114072,
                  end: 114271,
                  text: "Yeah, ",
                },
                {
                  start: 114352,
                  end: 114632,
                  text: "if ",
                },
                {
                  start: 114991,
                  end: 114991,
                  text: "I ",
                },
                {
                  start: 115112,
                  end: 115392,
                  text: "can ",
                },
                {
                  start: 115812,
                  end: 116032,
                  text: "make ",
                },
                {
                  start: 116092,
                  end: 116152,
                  text: "it ",
                },
                {
                  start: 116232,
                  end: 116592,
                  text: "here,",
                },
              ],
            },
            {
              start: 117372,
              end: 120092,
              text: "I can make it anywhere;",
              words: [
                {
                  start: 117372,
                  end: 117372,
                  text: "I ",
                },
                {
                  start: 117972,
                  end: 118092,
                  text: "can ",
                },
                {
                  start: 118211,
                  end: 118752,
                  text: "make ",
                },
                {
                  start: 118972,
                  end: 119092,
                  text: "it ",
                },
                {
                  start: 119192,
                  end: 120092,
                  text: "anywhere;",
                },
              ],
            },
            {},
            {
              start: 127910,
              end: 134750,
              text: "Making plans for killing myself;",
              words: [
                {
                  start: 127910,
                  end: 129470,
                  text: "Making ",
                },
                {
                  start: 129630,
                  end: 130370,
                  text: "plans ",
                },
                {
                  start: 130530,
                  end: 131170,
                  text: "for ",
                },
                {
                  start: 131410,
                  end: 133150,
                  text: "killing ",
                },
                {
                  start: 133190,
                  end: 134750,
                  text: "myself;",
                },
              ],
            },
            {},
            {
              start: 141970,
              end: 148070,
              text: "Have these kinds of thoughts leave this place?",
              words: [
                {
                  start: 141970,
                  end: 142770,
                  text: "Have ",
                },
                {
                  start: 142830,
                  end: 143630,
                  text: "these ",
                },
                {
                  start: 143730,
                  end: 144630,
                  text: "kinds ",
                },
                {
                  start: 144810,
                  end: 145150,
                  text: "of ",
                },
                {
                  start: 145430,
                  end: 146090,
                  text: "thoughts ",
                },
                {
                  start: 146390,
                  end: 146950,
                  text: "leave ",
                },
                {
                  start: 147130,
                  end: 147210,
                  text: "this ",
                },
                {
                  start: 147270,
                  end: 148070,
                  text: "place?",
                },
              ],
            },
            {},
            {
              start: 169489,
              end: 172709,
              text: "One day I'm gonna be;",
              words: [
                {
                  start: 169489,
                  end: 169849,
                  text: "One ",
                },
                {
                  start: 170249,
                  end: 170689,
                  text: "day ",
                },
                {
                  start: 171529,
                  end: 171769,
                  text: "I'm ",
                },
                {
                  start: 171989,
                  end: 172389,
                  text: "gonna ",
                },
                {
                  start: 172608,
                  end: 172709,
                  text: "be;",
                },
              ],
            },
            {},
            {
              start: 176509,
              end: 179989,
              text: "Who I want to be;",
              words: [
                {
                  start: 176509,
                  end: 177389,
                  text: "Who ",
                },
                {
                  start: 177809,
                  end: 177809,
                  text: "I ",
                },
                {
                  start: 178108,
                  end: 179009,
                  text: "want ",
                },
                {
                  start: 179049,
                  end: 179168,
                  text: "to ",
                },
                {
                  start: 179869,
                  end: 179989,
                  text: "be;",
                },
              ],
            },
            {},
            {
              start: 183069,
              end: 186168,
              text: "And you will be;",
              words: [
                {
                  start: 183069,
                  end: 183349,
                  text: "And ",
                },
                {
                  start: 183429,
                  end: 183509,
                  text: "you ",
                },
                {
                  start: 183549,
                  end: 183649,
                  text: "will ",
                },
                {
                  start: 185209,
                  end: 186168,
                  text: "be;",
                },
              ],
            },
            {
              start: 186906,
              end: 194226,
              text: "See what I see;",
              words: [
                {
                  start: 186906,
                  end: 187166,
                  text: "See ",
                },
                {
                  start: 190546,
                  end: 192726,
                  text: "what ",
                },
                {
                  start: 192766,
                  end: 192766,
                  text: "I ",
                },
                {
                  start: 193886,
                  end: 194226,
                  text: "see;",
                },
              ],
            },
            {},
            {
              start: 196426,
              end: 197986,
              text: "You know I'm gonna make it,",
              words: [
                {
                  start: 196426,
                  end: 196546,
                  text: "You ",
                },
                {
                  start: 196585,
                  end: 196906,
                  text: "know ",
                },
                {
                  start: 196966,
                  end: 197006,
                  text: "I'm ",
                },
                {
                  start: 197085,
                  end: 197386,
                  text: "gonna ",
                },
                {
                  start: 197506,
                  end: 197846,
                  text: "make ",
                },
                {
                  start: 197946,
                  end: 197986,
                  text: "it,",
                },
              ],
            },
            {
              start: 198085,
              end: 203046,
              text: "I'll make it somehow, yeah;",
              words: [
                {
                  start: 198085,
                  end: 198666,
                  text: "I'll ",
                },
                {
                  start: 199245,
                  end: 199585,
                  text: "make ",
                },
                {
                  start: 199886,
                  end: 200186,
                  text: "it ",
                },
                {
                  start: 200466,
                  end: 201745,
                  text: "somehow, ",
                },
                {
                  start: 201886,
                  end: 203046,
                  text: "yeah;",
                },
              ],
            },
            {
              start: 203085,
              end: 209085,
              text: "I'll get by with a little help from my friends;",
              words: [
                {
                  start: 203085,
                  end: 203166,
                  text: "I'll ",
                },
                {
                  start: 203286,
                  end: 203486,
                  text: "get ",
                },
                {
                  start: 203706,
                  end: 203805,
                  text: "by ",
                },
                {
                  start: 204186,
                  end: 204386,
                  text: "with ",
                },
                {
                  start: 204446,
                  end: 204446,
                  text: "a ",
                },
                {
                  start: 204606,
                  end: 204946,
                  text: "little ",
                },
                {
                  start: 205046,
                  end: 205386,
                  text: "help ",
                },
                {
                  start: 205706,
                  end: 205846,
                  text: "from ",
                },
                {
                  start: 205926,
                  end: 206146,
                  text: "my ",
                },
                {
                  start: 206305,
                  end: 209085,
                  text: "friends;",
                },
              ],
            },
            {},
            {
              start: 212554,
              end: 219334,
              text: "Making plans for killing myself;",
              words: [
                {
                  start: 212554,
                  end: 214054,
                  text: "Making ",
                },
                {
                  start: 214255,
                  end: 214995,
                  text: "plans ",
                },
                {
                  start: 215155,
                  end: 215815,
                  text: "for ",
                },
                {
                  start: 216054,
                  end: 217575,
                  text: "killing ",
                },
                {
                  start: 217815,
                  end: 219334,
                  text: "myself;",
                },
              ],
            },
            {},
            {
              start: 226774,
              end: 237674,
              text: "And these kinds of thoughts in these nights;",
              words: [
                {
                  start: 226774,
                  end: 227415,
                  text: "And ",
                },
                {
                  start: 227495,
                  end: 228295,
                  text: "these ",
                },
                {
                  start: 228355,
                  end: 229274,
                  text: "kinds ",
                },
                {
                  start: 229415,
                  end: 229954,
                  text: "of ",
                },
                {
                  start: 230095,
                  end: 230695,
                  text: "thoughts ",
                },
                {
                  start: 230734,
                  end: 230774,
                  text: "in ",
                },
                {
                  start: 231015,
                  end: 231635,
                  text: "these ",
                },
                {
                  start: 231894,
                  end: 237674,
                  text: "nights;",
                },
              ],
            },
          ],
        },
      ],
    },
  }
  renderData.waveformData = res.data.waves
  renderData.audioDuration = res.data.duration_milliseconds / 1000
  renderData.audioUrl =
    getObjectStorageFullUrl(res.data.mp3_url) + "?type=lyricsTranslator"
  renderData.title = res.data.title
  renderData.editMode = "editing"
  renderData.lyrics = res.data.lyrics
  stateData.parseResData = res.data
}

const init = async () => {
  if (props.item) {
    doInitEditClipBySong(props.item)
  } else {
    // initTestData();
  }
}

const poninterEvent = () => {
  if (renderData.visible) {
    if (props.item) {
      globalProperties.logCustomEvent("create_audio_edit_tab_stare_show", {
        tab_stare: "lyrics_translate",
        content_id: props.item?.song_id,
      })
    } else {
      globalProperties.logCustomEvent("create_audio_edit_tab_stare_show", {
        tab_stare: "lyrics_translate",
      })
    }
  }
}
watch(
  () => {
    return props.visible
  },
  () => {
    renderData.visible = props.visible
    poninterEvent()
  }
)
watch(
  () => {
    return renderData.visible
  },
  () => {
    emits("update:visible", renderData.visible)
  }
)

onMounted(() => {
  init()
  poninterEvent()
})
</script>
<style lang="scss">
.lyrics-translate-dialog {
  .lyrics-translate-dialog-subtitle {
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.5);
    margin: 3px 0 0 0;
    .lyrics-translate-dialog-subtitle-text {
      padding: 0 0 0 15px;
      position: relative;
      &:before {
        content: "";
        display: inline-block;
        width: 2px;
        height: 2px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        position: absolute;
        left: 5px;
        top: 9px;
      }
    }
  }
  &.lyrics-translate-dialog--mobile {
    .dialog-subtitle {
      display: none;
    }
  }
}
.lyrics-translate-dialog-container {
  padding: 13px 40px 40px 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .lyrics-translate-dialog-edit-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0;
    .lyrics-translate-dialog-media-box {
      border-radius: 16px 16px 0 0;
      background: rgba(148, 173, 255, 0.2);
    }
  }

  .lyrics-translate-dialog-media-upload {
  }
  .lyrics-translate-dialog-media-processing {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 194px;
    padding: 16px 0;
    .redm-processing-loading-box {
      width: 100px;
      height: 100px;
      position: relative;

      .redm-processing-loading {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: conic-gradient(
          from 180deg at 50% 50%,
          rgba(148, 173, 255, 0.28) 0deg,
          rgba(148, 173, 255, 0.8) 54deg,
          rgba(148, 173, 255, 0.2) 95deg,
          rgba(148, 173, 255, 0.1) 136deg,
          rgba(148, 173, 255, 0.28) 178deg,
          rgba(148, 173, 255, 0.8) 236deg,
          rgba(148, 173, 255, 0.2) 279deg,
          rgba(148, 173, 255, 0.1) 321deg,
          rgba(148, 173, 255, 0.28) 360deg,
          rgba(148, 173, 255, 0.8) 414deg
        );
      }
      .redm-processing-loading-ico {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;

        i {
          height: 32px;
          width: 48px;
          background: url(@/assets/img/editor/upload-drag-ico.png);
          background-size: 100% 100%;
        }
      }
    }
    .lyrics-translate-dialog-media-processing-text {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: normal;
      color: #ffffff;
      margin: 20px 0 0 0;
    }
  }
  .lyrics-translate-dialog-media-processfailed {
    padding: 24px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .region-processing-processfailed-ico {
      height: 60px;
      width: 60px;
      background: url(@/assets/img/editor/upload-processing-failed-ico.png);
      background-size: 100% 100%;
    }
    .lyrics-translate-dialog-media-processfailed-text {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 22px;
      color: #ffffff;
      margin: 12px 12px;
    }
    .lyrics-translate-dialog-media-processfailed-button {
      width: 140px;
    }
  }
  .lyrics-translate-dialog-media-edit {
    height: 162px;
  }
  .lyrics-translate-dialog-lyric-box {
    margin: 2px 0 0 0;
    height: 0;
    flex: 1;
    border-radius: 0px 0px 16px 16px;
    background: rgba(148, 173, 255, 0.2);
  }
  .lyrics-translate-dialog-notic {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    height: 100%;
    .lyrics-translate-dialog-notic-title {
      font-family: HarmonyOS Sans SC;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #ffffff;
    }
    .lyrics-translate-dialog-notic-text {
      display: flex;
      i {
        width: 2px;
        height: 2px;
        background: rgba(255, 255, 255, 1);
        border-radius: 50%;
        margin: 11px 15px 0 0;
      }
      span {
        font-family: HarmonyOS Sans SC;
        font-weight: 400;
        font-size: 15px;
        font-variation-settings: "opsz" auto;
        line-height: 24px;
        color: #ffffff;
        flex: 0 1 auto;
      }
    }
  }

  .lyrics-translate-dialog-button-box {
    margin: 20px 0 0 0;
  }
  &.lyrics-translate-dialog-container--mobile {
    padding: 13px 0 16px 0;
    .lyrics-translate-dialog-edit-box {
      padding: 0 16px;
    }
    .lyrics-translate-dialog-button-box {
      margin: 20px 16px 0 16px;
    }
    .lyrics-translate-dialog-media-processing {
      height: 160px;
      padding: 22px 0 16px 0;
      .redm-processing-loading-box {
        width: 80px;
        height: 80px;
        .redm-processing-loading-ico {
          i {
            height: 25px;
            width: 38px;
          }
        }
      }
      .lyrics-translate-dialog-media-processing-text {
        font-size: 14px;
        line-height: 16px;
        margin: 12px 0 0 0;
      }
    }
    .edit-wave-player-select-area-edit-box {
      overflow-y: auto;
      padding: 0 16px;
    }
    .lyrics-translate-dialog-media-edit {
      height: 152px;
    }
  }
}

.el-popper.is-dark.lyrics-translate-dialog-question-popper {
  width: 273px;
  padding: 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(30px);
  .lyrics-translate-dialog-question-content {
    .lyrics-translate-dialog-question-content-title {
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 22px;
      font-weight: 700;
      font-size: 14px;
    }
    .lyrics-translate-dialog-question-content-text {
      font-family: HarmonyOS Sans SC;
      font-weight: 400;
      font-size: 14px;
      font-variation-settings: "opsz" auto;
      line-height: 22px;
      i {
        height: 2px;
        width: 2px;
        min-width: 2px;
        border-radius: 50%;
        background: #ffffff;
        margin: 10px 8px 0 0;
        display: inline-block;
      }
      span {
        width: 0;
        flex: 1;
      }
    }
  }
}
</style>
